import axios, { AxiosInstance } from 'axios'
import BaseConfig from '@/utils/config'
import Common from '@/utils/common'

import Store from '@/store'

interface InstanceOptions {
    baseURL: string;
    timeout: number;
}

class Instance {
    public options: InstanceOptions = {
        baseURL: '',
        timeout: 10000
    }

    constructor (options: InstanceOptions) {
        this.options = options
    }

    interceptor () {
        const _this = this
        const instance: AxiosInstance = axios.create(_this.options)
        instance.interceptors.request.use(
            config => {
                return config
            },
            error => {
                return Promise.reject(error)
            }
        )
        instance.interceptors.response.use(
            response => {
                return response.data ? response.data : response
            }, (error: any) => {
                // 超时重新请求
                const config = error.config
                // 全局的请求次数,请求的间隙
                const [RETRY_COUNT, RETRY_DELAY] = [3, 1000]
                if (config && RETRY_COUNT) {
                    // 设置用于跟踪重试计数的变量
                    config.__retryCount = config.__retryCount || 0
                    // 检查是否已经把重试的总数用完
                    if (config.__retryCount >= RETRY_COUNT) {
                        return Promise.reject(error)
                    }
                    // 增加重试计数
                    config.__retryCount++
                    // 创造新的Promise来处理指数后退
                    const backoff = new Promise((resolve) => {
                        setTimeout(() => {
                            resolve('')
                        }, RETRY_DELAY || 1)
                    })
                    // instance重试请求的Promise
                    return backoff.then(() => {
                        return instance(config)
                    })
                }
                return Promise.reject(error)
            }
        )
        return instance
    }
}

const httpInstance = new Instance({
    baseURL: BaseConfig.HTTP_URL,
    timeout: 10000
}).interceptor()

const activityInstance = new Instance({
    baseURL: BaseConfig.ACTIVITY_URL,
    timeout: 10000
}).interceptor()

export function $http(url: string, params: any, method: string = 'post') {
    return new Promise((resolve, reject) => {
        httpInstance[method](url, method === 'post' ? 'data=' + JSON.stringify(params) : {
            params
        }).then((res: any) => {
            if (res && (res.status == 0 || res.status == 200)) {
                resolve(res.data ? res.data : res)
            } else {
                reject(res)
            }
        }).catch(() => {
            reject()
        })
    })
}

export function $request(url: string, params: any, method: string = 'get') {
    return new Promise((resolve, reject) => {
        activityInstance[method](url, method == 'get' ? {
            params
        } : params).then((res: any) => {
            if (res && res.errno == 0) {
                resolve(res.data ? res.data : res)
            } else if (res && res.errno == 1250) {
                Store.commit('SET_DIALOGDATA', {
                    text: '亲，微信绑定，才可以抽取现金红包哦，抽取现金后，金额将自动存入您的微信零钱哦！',
                    btns: [
                        {
                            text: '取消',
                            className: 'cancel-btn'
                        },
                        {
                            text: '确定',
                            className: 'wxAuthorize-btn'
                        }
                    ]
                })
            } else if (res && res.errno == 1010) {
                // 人机验证
                const data = res.data
                Common.captcha(data).then(() => {
                    // 继续调用之前需要人机验证的接口
                    activityInstance[method](url, method == 'get' ? {
                        params
                    } : params).then((againRes: any) => {
                        // 调用接口成功
                        if (againRes && againRes.errno == 0) {
                            resolve(againRes.data ? againRes.data : againRes)
                        } else {
                            reject(res)
                            Common.toast('安全验证失败，请重试')
                        }
                    }).catch(() => {
                        reject(res)
                        Common.toast('安全验证失败，请重试')
                    })
                }).catch(() => {
                    reject(res)
                    Common.toast('安全验证失败，请重试')
                })
            } else {
                reject(res)
            }
        }).catch(() => {
            reject()
        })
    })
}
